'use strict';

/**
 * Module definition for LocationModule
 *
 * @category   Module
 * @module     LocationModule
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.de)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var Controller = require('./controller');
var Wreqr = require('./wreqr');
var StoragesCollection = require('./collections/storages');

var StorageModule = Marionette.Module.extend({
    startWithParent: true,

    initialize: function(moduleName, app) {},

    onStart: function(options) {
        var controller = this.controller = new Controller({
            app: app,
            module: this,
        });

        this.wreqr = new Wreqr({
            app: app,
            module: this,
        });

        App.addInitializer(function(){
            App.router.processAppRoutes(controller, controller.routes);
        });
    },
});

module.exports = StorageModule;